import {
    ACCOUNTS_INSTANCE,
    EVENTCHAIN_INSTANCE,
    ORGANIZATION_INSTANCE,
    PASS_ORDER_INSTANCE,
    PLACES_INSTANCE
} from "@/helper/consts";

import Breadcrumbs from "@/modules/admin/Breadcrumbs";
import names from "@/modules/admin/routers/names";
import CarsBreadcrumbs from "@/modules/admin/cars/CarsBreadcrumbs";
import FileBreadcrumbs from "@/modules/admin/file/FileBreadcrumbs";
import FieldsBreadcrumbs from "@/modules/admin/fields/FieldsBreadcrumbs";
import OrdersBreadcrumbs from "@/modules/admin/orders/OrdersBreadcrumbs";
import RolesBreadcrumbs from "@/modules/admin/roles/RolesBreadcrumbs";
import VisitorsBreadcrumbs from "@/modules/admin/visitors/VisitorsBreadcrumbs";
import CarsDetail from "../cars/pages/Detail"
import OrdersDetail from "../orders/pages/Detail"
import OrdersLog from "../orders/pages/Log"
import RolesLog from "../roles/pages/Log"
import VisitorsDetail from "../visitors/pages/Detail"
import ChatsBreadcrumbs from "@/modules/admin/chats/ChatsBreadcrumbs";
import OrganizationsBreadcrumbs from "@/modules/admin/organizations/OrganizationsBreadcrumbs";
import GuardPostsBreadcrumbs from "@/modules/admin/guardposts/GuardPostsBreadcrumbs";
import GuardPostsDetail from "@/modules/admin/guardposts/pages/Detail";
import FileDetail from "../file/pages/Detail"
import OrdersFile from "../orders/pages/File"
import BansList from "@/modules/admin/bans/BansList.vue";
import AdminReplacementList from "@/modules/admin/replacements/ReplacementsList.vue";
export default ([
    {
        path: "/admin",
        name: names.MAIN,
        component: Breadcrumbs,
        meta: {
            breadcrumb: "Администратор",
            requiredAuth: true,
            instances: [
                PASS_ORDER_INSTANCE,
                ACCOUNTS_INSTANCE,
                EVENTCHAIN_INSTANCE
            ]
        },
        children: [
            {
                path: "cars",
                name: names.CARS.LIST,
                component: CarsBreadcrumbs,
                meta: {
                    breadcrumb: "Автомобили",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idCars",
                        name: names.CARS.DETAIL,
                        component: CarsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "file",
                name: names.FILE.LIST,
                component: FileBreadcrumbs,
                meta: {
                    breadcrumb: "Файлы выгрузок",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idFile",
                        name: names.FILE.DETAIL,
                        component: FileDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "fields",
                name: names.FIELDS.LIST,
                component: FieldsBreadcrumbs,
                meta: {
                    breadcrumb: "Списки полей сведений",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "orders",
                name: names.ORDERS.LIST,
                component: OrdersBreadcrumbs,
                meta: {
                    breadcrumb: "Заявки",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        PLACES_INSTANCE
                    ]
                },
                children: [
                    {
                        path: "file/:idFile",
                        name: names.ORDERS.FILE,
                        component: OrdersFile,
                        meta: {
                            breadcrumb: "Файл",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    },
                    {
                        path: ":idOrders",
                        name: names.ORDERS.DETAIL,
                        component: OrdersDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    },
                    {
                        path: ":idOrders/log",
                        name: names.ORDERS.LOG,
                        component: OrdersLog,
                        meta: {
                            breadcrumb: "Журнал логирования",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "roles",
                name: names.ROLES.LIST,
                component: RolesBreadcrumbs,
                meta: {
                    breadcrumb: "Роли",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        PLACES_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idRoles/log",
                        name: names.ROLES.LOG,
                        component: RolesLog,
                        meta: {
                            breadcrumb: "Журнал логирования",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "visitors",
                name: names.VISITORS.LIST,
                component: VisitorsBreadcrumbs,
                meta: {
                    breadcrumb: "Посетители",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idVisitors",
                        name: names.VISITORS.DETAIL,
                        component: VisitorsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "chats",
                name: names.CHATS.LIST,
                component: ChatsBreadcrumbs,
                meta: {
                    breadcrumb: "Чаты",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "organizations",
                name: names.ORGANIZATIONS.LIST,
                component: OrganizationsBreadcrumbs,
                meta: {
                    breadcrumb: "Организации",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "bans",
                name: names.BANS.LIST,
                component: BansList,
                meta: {
                    breadcrumb: "Заблокированные пользователи",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "replacements",
                name: names.REPLACEMENTS.LIST,
                component: AdminReplacementList,
                meta: {
                    breadcrumb: "Список заместителей",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "guardposts",
                name: names.GUARD_POSTS.LIST,
                component: GuardPostsBreadcrumbs,
                meta: {
                    breadcrumb: "Посты охраны",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        PLACES_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idGuardPost",
                        name: names.GUARD_POSTS.DETAIL,
                        component: GuardPostsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            }
        ]
    }
])
